import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Container, Paper } from "@mui/material";
import Header from "../../components/Header/userHeader";
import { UserFooter } from "../../components";
import ScrollToTopButton from "../../components/ScrollToTop";
import category1 from "../../assets/images/Home_page_image/categories1.png";
import category2 from "../../assets/images/Home_page_image/categories2.png";
import category3 from "../../assets/images/Home_page_image/categories3.png";
import category4 from "../../assets/images/Home_page_image/categories.4.png";
import category5 from "../../assets/images/Home_page_image/categories1.png";
import category6 from "../../assets/images/Home_page_image/categories2.png";
import category7 from "../../assets/images/Home_page_image/categories3.png";
import category8 from "../../assets/images/Home_page_image/categories.4.png";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch } from "../../hooks";

// const categories = [
//   { name: "Groceries", image: category1 },
//   { name: "Electronics", image: category2 },
//   { name: "Home Appliances", image: category3 },
//   { name: "Vehicles", image: category4 },
//   { name: "Books", image: category5 },
//   { name: "Fashion", image: category6 },
//   { name: "Toys", image: category7 },
//   { name: "Sports", image: category8 },
// ];

  
  

export const Seeallcategories = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const apptoken = useSelector((state) => state.user.apptoken);
  const latitude = useSelector(
      (state) => state.user.userLocation?.latitude ?? null
    );
    const longitude = useSelector(
      (state) => state.user.userLocation?.longitude ?? null
    );
  useEffect(() => {
    if (apptoken) {
      fetchData();
    }
  }, [apptoken]);

   const {
      data: categoryData,
      isLoading: isCategoriedLoading,
      error,
      fetchData,
    } = useFetch(BASE_URL_TEST + urls("getAllCategories"), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: apptoken ? `Bearer ${apptoken}` : "",
      },
    });
  
    useEffect(() => {
      if (categoryData && categoryData["status"] === true) {
        const dynamicCategories = categoryData.data.map((item) => ({
          name: item.name,
          description: item.description,
          image: item.image_url,
          categoryId: item.category_id
        }));
        setCategories(dynamicCategories);
      }
    }, [categoryData]);
  
    const handleImageClick = async (categoryid) => {
      console.log("categoryid", categoryid);
  
      const radius = 20;
      const vtype = "regular";
  
      try {
        const response = await fetch(
          `${BASE_URL_TEST}/api/main/vendors?lat=${latitude}&lng=${longitude}&radius=${radius}&vtype=${vtype}&categoryids=${categoryid}`
        );
  
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        if (data?.vendors) {
          console.log("categories",data.vendors);
          const formattedVendors = data.vendors.map((item) => ({
            id: item.id,
            name: item.name,
            shopName: item.shop_name,
            description:
              Array.isArray(item.categories) && item.categories.length > 0
                ? item.categories.map((c) => c.description).join(", ")
                : Array.isArray(item.listCategories) &&
                  item.listCategories.length > 0
                ? item.listCategories.map((c) => c.description).join(", ")
                : "",
            image: item.store_image,
            distance: item.distance
              ? `${item.distance} kms near to your Location`
              : "N/A",
            rating: "4.8" || "N/A",
            address: `${item.street}, ${item.city}, ${item.state}, ${item.country}, ${item.pincode}`,
            openTime: item.open_time,
            closeTime: item.close_time,
            latitude: item.latitude,
            longitude: item.longitude,
            phoneNumber: item.phone_number,
            regularListType:item.reg_list_type
          }));
  
          navigate(`/categorys/${categoryid}`, {
            state: { vendors: formattedVendors, categoryName: categoryid },
          });
  
          console.log("Formatted Vendors data:", formattedVendors);
        } else {
          console.error("No vendors found in the response data");
        }
      } catch (error) {
        console.error("API call failed:", error);
      }
    };

  return (
    <>
      <Header />
      <Container
        maxWidth="xl"
        sx={{
          my: 2,
          px: { xs: 1.5, sm: 2, md: 3 },
          width: "100%",
          maxWidth: "100%",
          overflowX: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Box sx={{ textAlign: "left", width: "100%" }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              marginBottom: 3,
              ml: 3,
              color: "#2D3748",
              fontSize: {
                xs: "1rem",
                sm: "1.5rem",
                md: "1.75rem",
                lg: "1,75rem",
              },
              position: "relative",
              paddingBottom: 1.5,
              "&:after": {
                content: '""',
                position: "absolute",
                left: 0,
                bottom: 0,
                height: "4px",
                width: "60px",
                background: "linear-gradient(90deg, #6366F1 0%, #8B5CF6 100%)",
                borderRadius: "2px",
              },
            }}
          >
            Categories
          </Typography>
        </Box>

        <Paper
          elevation={0}
          sx={{
            background: "linear-gradient(135deg, #EDF2F7 0%, #E2E8F0 100%)",
            borderRadius: "16px",
            padding: { xs: 2, sm: 3, md: 4 },
            mt: 3,
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(2, 1fr)",
                sm: "repeat(3, 1fr)",
                md: "repeat(5, 1fr)",
              },
              gap: { xs: 2, sm: 3, md: 4 },
              width: "100%",
            }}
          >
            {categories.map((category) => (
              <Paper
                key={category.name}
                elevation={2}
                sx={{
                  overflow: "hidden",
                  borderRadius: "12px",
                  background: "#FFFFFF",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: "0 12px 28px rgba(0, 0, 0, 0.12)",
                  },
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    overflow: "hidden",
                    paddingTop: "75%", // Improved aspect ratio
                  }}
                >
                  <Box
                    component="img"
                    src={category.image}
                    alt={category.name}
                    onClick={() => handleImageClick(category.categoryId)}
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      cursor: "pointer",
                      transition: "transform 0.5s ease",
                      "&:hover": {
                        transform: "scale(1.08)",
                      },
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    padding: { xs: 1.5, sm: 2 },
                    textAlign: "center",
                    borderTop: "1px solid #EDF2F7",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "14px", sm: "16px", md: "16px" },
                      fontWeight: 600,
                      color: "#000000", // Changed to black
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      textTransform: "none",
                    }}
                  >
                    {category.name}
                  </Typography>
                </Box>
              </Paper>
            ))}
          </Box>
        </Paper>
      </Container>
      <UserFooter />
      <ScrollToTopButton />
    </>
  );
};
